import authModule from "@/store/auth.module";
import MQTTClient from "./mqttclient";
import dataresponse from "@/model/response/dataresponse";
import historydatabaserequest from "@/model/requests/historydatabaserequest";
import historydatarequest from "@/model/requests/historydatarequest";
import historydbtablerequest from "@/model/requests/historydbtablerequest";

let client: MQTTClient;
let auth: { type: string; token?: string; username?: string; password?: string } | null = null;
const brokerRequests: Map<string, (msg: any) => void> = new Map();
const historyRequests: Map<string, (msg: any) => void> = new Map();
const historyDBRequests: Map<string, (msg: any) => void> = new Map();
const eventsRequests: Map<string, (msg: any) => void> = new Map();
const historyTableRequests: Map<string, (msg: any) => void> = new Map();
const screenRequests: Map<string, (msg: any) => void> = new Map();
const logRequests: Map<string, (msg: any) => void> = new Map();
const streamRequests: Map<string, (msg: any) => void> = new Map();
const timers = new Map();

let onNextTag: ((data: string) => void) | undefined;
const TESLABROKER = "TESLABROKER/";

export const NODE_CONTROL = {
    COMMANDS: {
        TAG_HISTORY:"NCMD/HISTORY",
        TAG_HISTORY_FROM_DB: "NCMD/DBHISTORY",
        TAG_HISTORY_DB_TABLE:"NCMD/DBTABLEHISTORY",
        TAG_EVENTS: "NCMD/EVENTS",
        TAG_SCREEN: "NCMD/SCREEN",
        SCREEN_INFO: "NCMD/INFOSCREEN",
        EVENTS_TABLE: "NCMD/TABLEEVENTS",
        GET_LOG: "NCMD/GETLOG",
        DEBUG_LEVEL: "NCMD/DEBUGLEVEL"
    } as const,

    DATA: {
        TAG_HISTORY: "NDATA/HISTORY",
        TAG_HISTORY_FROM_DB: "NDATA/DBHISTORY",
        TAG_HISTORY_DB_TABLE: "NDATA/DBTABLEHISTORY",
        TAG_EVENTS: "NDATA/EVENTS",
        TAG_SCREEN: "NDATA/SCREEN",
        SCREEN_INFO: "NDATA/INFOSCREEN",
        EVENTS_TABLE: "NDATA/TABLEEVENTS",
        LOG: "NDATA/LOG"
    } as const
};

export async function connect(): Promise<void> {

    if (client == null) {
        console.log("connect")
        if (authModule.currentUser != null) {
            bearerAuth(authModule.currentUser.accessToken)
        }
        
        if (auth != null)
            client = new MQTTClient(process.env.VUE_APP_MQTT_URL, auth.username, auth.password)
        else
            client = new MQTTClient(process.env.VUE_APP_MQTT_URL, null, null)

        /*await client.connect(handleResponse.bind(this),
            () => {
                client.subscribe(TESLABROKER + "#");
            }, (err) => {
                console.log("connection error:" + err.message)
                 reject(err);
            });*/
        await new Promise<void>((resolve, reject) => {
            client.connect(
                handleResponse.bind(this),
                () => {
                    if (client != null)
                        client.subscribe(TESLABROKER + "#");
                    resolve();
                },
                (err) => {
                    console.log("connection error:" + err.message)
                    reject(err);
                }
            );
        });
    }
}
export function setOnNextTag(onNext: (data: string) => void) {
    onNextTag = onNext;
}

export function logout() {
    auth = null;
}
export function bearerAuth(token: string) {
    auth = { type: "bearer", token: token, username: "token", password: token };
}
export async function subscribe(topic: string) {
    await connect();
    client.subscribe(topic);
}
export async function unsubscribe(topic: string) {
    await connect();
    client.unsubscribe(topic);
}
export function simpleMQTTAuth(username: string, password: string) {
    auth = { type: "simple", username: username, password: password };
    //disconnect()
    //client = null
}

function handleResponse(topic: string, msg: string) {
    console.log("Response: topic:" + topic + " message:" + msg)
    try {
        if (topic.startsWith(TESLABROKER)) {
            if (topic.startsWith(TESLABROKER+NODE_CONTROL.DATA.TAG_HISTORY_DB_TABLE)) {
                const response: dataresponse = JSON.parse(msg);
                if (historyTableRequests.has(response.name)) {
                    const resolver = historyTableRequests.get(response.name)!;// eslint-disable-line @typescript-eslint/no-non-null-assertion
                    resolver(response.data)
                    historyTableRequests.delete(response.name);
                    checkTimers(response.name)
                }
            }
            else if (topic.startsWith(TESLABROKER+NODE_CONTROL.DATA.TAG_HISTORY_FROM_DB)) {
                const response: dataresponse = JSON.parse(msg);
                if (historyDBRequests.has(response.name)) {
                    const resolver = historyDBRequests.get(response.name)!;// eslint-disable-line @typescript-eslint/no-non-null-assertion
                    resolver(response.data)
                    historyDBRequests.delete(response.name);
                     checkTimers(response.name)
                }
            }
            else if (topic.startsWith(TESLABROKER+NODE_CONTROL.DATA.TAG_HISTORY)) {
                const response: dataresponse = JSON.parse(msg);
                if (historyRequests.has(response.name)) {
                    const resolver = historyRequests.get(response.name)!;// eslint-disable-line @typescript-eslint/no-non-null-assertion
                    resolver(response.data)
                    historyRequests.delete(response.name);
                     checkTimers(response.name)
                }
            }

            else if (topic.startsWith(TESLABROKER+NODE_CONTROL.DATA.TAG_EVENTS)) {
                const response: dataresponse = JSON.parse(msg);
                if (eventsRequests.has(response.name)) {
                    const resolver = eventsRequests.get(response.name)!;// eslint-disable-line @typescript-eslint/no-non-null-assertion
                    resolver(response.data)
                    eventsRequests.delete(response.name);
                     checkTimers(response.name)
                }
            }
            
            else if (topic.startsWith(TESLABROKER+NODE_CONTROL.DATA.TAG_SCREEN)) {
                if (screenRequests.has(topic)) {
                    const response: dataresponse = JSON.parse(msg);
                    const resolver = screenRequests.get(topic)!;// eslint-disable-line @typescript-eslint/no-non-null-assertion
                    resolver(response.data);
                    screenRequests.delete(topic);
                     checkTimers(topic)
                }
            }
            else if (topic.startsWith(TESLABROKER+NODE_CONTROL.DATA.LOG)) {
                if (logRequests.has(topic)) {
                    //const response: dataresponse = JSON.parse(msg);
                    const resolver = logRequests.get(topic)!;// eslint-disable-line @typescript-eslint/no-non-null-assertion
                    resolver(msg);
                    logRequests.delete(topic);
                     checkTimers(topic)
                }
            }
            else {
                console.log("else"+ streamRequests.keys().next().value+ " "+topic)
                if (brokerRequests.has(topic)) {
                    const resolver = brokerRequests.get(topic)!;// eslint-disable-line @typescript-eslint/no-non-null-assertion
                    resolver(msg);
                    brokerRequests.delete(topic);
                }
                else if (streamRequests.has(topic)) {
                    const resolver = streamRequests.get(topic);
                    resolver(msg);
                }
            }
        }
        else {
            if (onNextTag != null)
                onNextTag(msg)
        }
    } catch (e) {
        console.error("[MqttService] Failed to parse response:", e);
    }
}
export async function checkTimers(key:string){
     if (timers.has(key)){
            const timerId = timers.get(key)
            clearTimeout(timerId)
            timers.delete(key)
        }
}
export async function requestResponseMQTT<T = any>(data: any, route: string,
    onSuccess: (resp: any) => void,
    onError?: (err: any) => void,
    timeout = 20000): Promise<T> {
    try {
        await connect();
    } catch (err) {
        onError?.(err);
        disconnect()
        return new Promise(() => { console.log("Connection Error") });
    }
    console.log("TOPIC:"+route)
    return new Promise(() => {
        const topic = TESLABROKER+route;
        let resptopic = topic;
        checkTimers(resptopic)
       /* if (timers.has(resptopic)){
            const timerId = timers.get(resptopic)
            clearTimeout(timerId)
            timers.delete(resptopic)
        }*/
        if (topic.startsWith(TESLABROKER+NODE_CONTROL.COMMANDS.TAG_HISTORY_DB_TABLE)) {
            const request = data as historydbtablerequest
            resptopic = request.name
            historyTableRequests.set(resptopic, (resp) => onSuccess(resp));
        }
         else if (topic.startsWith(TESLABROKER+NODE_CONTROL.COMMANDS.TAG_HISTORY_FROM_DB)) {
            const request = data as historydatabaserequest
            resptopic = request.name
            historyDBRequests.set(resptopic, (resp) => onSuccess(resp));
        }
        else if (topic.startsWith(TESLABROKER+NODE_CONTROL.COMMANDS.TAG_HISTORY)) {
            const request = data as historydatarequest
            resptopic = request.name
            historyRequests.set(resptopic, (resp) => onSuccess(resp));
        }
        else if (topic.startsWith(TESLABROKER+NODE_CONTROL.COMMANDS.TAG_EVENTS)) {
            resptopic = 'eventstable'
            eventsRequests.set(resptopic, (resp) => onSuccess(resp));
        } 
        else if (topic.startsWith(TESLABROKER+NODE_CONTROL.COMMANDS.TAG_SCREEN)) {
            console.log("GETSCREEN")
            resptopic = TESLABROKER+NODE_CONTROL.DATA.TAG_SCREEN
            console.log(resptopic)
            screenRequests.set(resptopic, (resp) => onSuccess(resp));
        }
        else if (topic.startsWith(TESLABROKER+NODE_CONTROL.COMMANDS.GET_LOG)){
            console.log("GETLOG")
            resptopic = TESLABROKER+NODE_CONTROL.DATA.LOG
            console.log(resptopic)
            logRequests.set(resptopic, (resp) => onSuccess(resp));
        }
        else {
            resptopic = topic
            brokerRequests.set(resptopic, (resp) => onSuccess(resp));
        }
        console.log(resptopic)
        client.publish(topic, data);
        const timerId = setTimeout(() => {

            if (brokerRequests.has(resptopic)) {
                brokerRequests.delete(resptopic);
                onError?.(new Error("Timeout waiting for response"));
                //disconnect();
            }
            else if (historyRequests.has(resptopic)) {
                historyRequests.delete(resptopic);
                onError?.(new Error("Timeout waiting for response"));
                //disconnect();
            }
            else if (historyDBRequests.has(resptopic)) {
                historyDBRequests.delete(resptopic);
                onError?.(new Error("Timeout waiting for response"));
                //disconnect();
            }
            else if (eventsRequests.has(resptopic)) {
                eventsRequests.delete(resptopic);
                onError?.(new Error("Timeout waiting for response"));
                //disconnect();
            }
            else if (screenRequests.has(resptopic)) {
                screenRequests.delete(resptopic);
                onError?.(new Error("Timeout waiting for response"));
                //disconnect();
            }

        }, timeout);

        timers.set(resptopic, timerId)
    });
}

export async function requestStreamMQTT(route: string, data: any, onNext: (msg: any) => void): Promise<void> {
    await connect();
    console.log("requestStreamMQTT:", route, " data:", data)
    const topic = TESLABROKER+route;
    streamRequests.set(topic, (resp) => onNext(resp));
    client.publish(topic, data)
}

export async function publish(topic: string, data: any) {
    await connect();
    if (client == null) return
    client.publish(topic, data);
}

export function disconnect() {
    if (client != null)
        client.disconnect();
    client = null;
}
export function setMQTTToken(token: string): void {
    if (token == null)
        logout();
    else
        bearerAuth(token);
}


